export enum OrderType {
  Recurring = "recurring",
  OneTime = "general",
}

export enum ProductCategory {
  Plan = "plan",
  Consumable = "consumable",
}

export enum ProductItemType {
  Plan = "Plan",
  Consumable = "Consumable",
}

export enum ConsumableType {
  HotEvent = "hot_event",
}
export type Plan = {
  id: string;
  title: string;
  tag: string;
  isOneTime: boolean;
  duration: {
    months?: number;
    days?: number;
  };
  description: string;
};

export type Consumable = {
  id: string;
  title: string;
  type: ConsumableType;
  isActive: true;
};

export type PaymentOrder = {
  id: string;
  price: number;
  type: OrderType;
  products: Array<{
    quantity: number;
    product: {
      id: string;
      price: number;
      category: ProductCategory;
      allowedPaymentSystems: { name: string }[];
      items: (
        | { itemType: ProductItemType.Plan; item: Plan }
        | { itemType: ProductItemType.Consumable; item: Consumable }
      )[];
    };
  }>;
  isPaid: boolean;
  paidAt?: string;
  revokedAt?: string;
  createdAt: string;
};
